import { TablePagination as MuiPagination } from '@mui/material'
import { TablePaginationActionsProps } from '@mui/material/TablePagination/TablePaginationActions'
import React from 'react'
import { TablePaginationActions } from './TablePaginationActions'

interface TablePaginationProps {
  count: number
  rowsPerPage: number
  page: number
  onPageChange: (event: unknown, newPage: number) => void
  onRowsPerPageChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
  ActionsComponent?: React.ElementType<TablePaginationActionsProps>
}

export const TablePagination: React.FC<TablePaginationProps> = ({
  count = 0,
  rowsPerPage = 1,
  page = 1,
  onPageChange,
  onRowsPerPageChange,
  ActionsComponent = TablePaginationActions,
}) => (
  <MuiPagination
    rowsPerPageOptions={[]}
    component="div"
    count={count}
    rowsPerPage={rowsPerPage}
    sx={{
      fontSize: '12px',
      fontStyle: 'normal',
      lineHeight: '20px',
      fontWeight: 'Regular',
    }}
    page={page}
    onPageChange={onPageChange}
    onRowsPerPageChange={onRowsPerPageChange}
    ActionsComponent={ActionsComponent}
  />
)
